let MyData = [
    {
        id : 1,
        imglink: "https://m.media-amazon.com/images/I/81akueB8XVL.jpg",
        title: "strabger things",
        netflix: "netflix originals series",
        link: "https://www.netflix.com/in/title/80057281"
    },
    {
        id : 2, 
        imglink: "https://m.media-amazon.com/images/M/MV5BMDk3YzgxNDQtNTEzOS00NDMyLWFlYmYtYTZlMDk1NDkxNmMyXkEyXkFqcGdeQXVyNzA5NjUyNjM@._V1_.jpg",
        title: "The vampire diaries",
        netflix: "netflix originals series",
        link: "https://www.netflix.com/in/title/70143860"
    },
    {
        id : 3, 
        imglink: "https://e1.pxfuel.com/desktop-wallpaper/635/548/desktop-wallpaper-all-of-us-are-dead-cast-all-of-us-are-dead-thumbnail.jpg",
        title: "all of us are dead",
        netflix: "netflix originals series",
        link: "https://www.netflix.com/title/81237994"
    },
    {
        id : 4,
        imglink: "https://i.etsystatic.com/13367669/r/il/ef44ea/3447776044/il_570xN.3447776044_muz4.jpg",
        title: "the witcher",
        netflix: "netflix originals series",
        link: "https://www.netflix.com/title/80189685"
    },
    {
        id : 5, 
        imglink: "https://static.toiimg.com/photo/msid-102396343/102396343.jpg?14552",
        title: "choona",
        netflix: "netflix originals series",
        link: "https://www.netflix.com/title/81264055"
    },
    {
        id : 6,
        imglink:"https://m.media-amazon.com/images/I/81nMPKCsoML._AC_UF1000,1000_QL80_.jpg",
        title:"One Piece",
        netflix:"netflix originals series",
        link:"https://www.netflix.com/title/80217863"
    },
    {
        id : 7,
        imglink:"https://rukminim2.flixcart.com/image/850/1000/l0igvww0/poster/5/q/q/medium-marvel-thor-ragnarok-no-16-wall-poster-print-on-art-paper-original-imagcaf9fnn3svev.jpeg?q=20",
        title:"Ragnarok",
        netflix:"netflix originals series",
        link:"https://www.netflix.com/title/80232926"
    }, 
    {
        id : 8,
        imglink:"https://flxt.tmsimg.com/assets/p16531142_b_v10_ad.jpg",
        title:"Hanna  ",
        netflix:"amazon prime series",
        link:"https://www.primevideo.com/detail/Hanna/0GDQD61DFTIOW70O03Z2KDUY84"
    },
    {
        id : 9,
        imglink:"https://flxt.tmsimg.com/assets/p23280918_b_v10_aa.jpg",
        title:"The Devil's Hour ",
        netflix:"amazon prime series",
        link:"https://www.primevideo.com/detail/The-Devils-Hour/0O60NCJ6DOQX1ILR17G161O60A"
    },
    {
        id : 10,
        imglink:"https://m.media-amazon.com/images/M/MV5BODU0MmZjYjktOGQ4MS00N2QwLTk5MzQtYTRkMGRiM2Q4ZjViXkEyXkFqcGdeQXVyMjkwOTAyMDU@._V1_.jpg",
        title:"Tom Clancy's Jack Ryan",
        netflix:"amazon prime series",
        link:"https://www.primevideo.com/detail/Tom-Clancys-Jack-Ryan/0IMOE9I1H3BN74ON17M9XGZFPG"
    },
    {
        id : 11,
        imglink:"https://rukminim1.flixcart.com/image/850/1000/l0h1g280/poster/w/g/d/small-mirzapur-web-series-poster-multicolor-photopaper-print-12-original-imagc95dpwwmqcbg.jpeg?q=90",
        title:"Mirzapur",
        netflix:"amazon prime series",
        link:"https://www.primevideo.com/detail/Mirzapur/0PDOKMV9CRLOMO5EUKNCUJLG4Q"
    },
    {
        id : 12,
        imglink:"https://seniorstoday.in/wp-content/uploads/2022/02/Reacher-amazon-prime-Review-by-Deepa-Gahlot-of-Seniors-Today.jpg",
        title:"Reacher",
        netflix:"amazon prime series",
        link:"https://www.primevideo.com/detail/Reacher/0RTZ57DQ6PBHH29UN5JS7U7CW4"
    },
    {
        id : 13,
        imglink:"https://hamaraphotos.com/wp-content/uploads/2023/04/Citadel-Poster-Wide.jpg",
        title:"Citadel",
        netflix:"amazon prime series",
        link:"https://www.primevideo.com/detail/Citadel/0U5UNXQ1U9T6S6J2XCIV6UAMWF"
    },
    {
        id : 14,
        imglink:"https://flxt.tmsimg.com/assets/p21675914_b_v13_aa.jpg",
        title:"The Terminal List",
        netflix:"amazon prime series",
        link:"https://www.primevideo.com/detail/The-Terminal-List/0NGB908JKDOZ29WLQ2GS45USOV"
    },


]






export default MyData;